import axios, { AxiosInstance } from 'axios';
import { getToken, removeToken } from '@/utils/auth'
import { message } from 'ant-design-vue';
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

const service: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,  // 开发环境使用代理
  timeout: 60000,
  withCredentials: true  // 允许跨域请求携带凭证
})

// 添加请求拦截器
service.interceptors.request.use(config => {
  // 某些公开接口不需要token
  const token = getToken()
  if (token && token !== 'undefined') {
    config.headers['lxcf-raindrop-token'] = token
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params);
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }

  // 确保 url 以 / 开头
  if (config.url && !config.url.startsWith('/')) {
    config.url = '/' + config.url;
  }

  if (config.data instanceof FormData) {
    config.headers['Content-Type'] = 'multipart/form-data';
  } else if (config.method === 'post' || config.method === 'put') {
    const requestObj = {
      url: config.url,
      data: JSON.stringify(config.data),
      time: new Date().getTime()
    }
    const requestSize = Object.keys(JSON.stringify(requestObj)).length; // 请求数据大小
    const limitSize = 5 * 1024 * 1024; // 限制存放数据5M
    if (requestSize >= limitSize) {
      console.warn(`[${config.url}]: ` + '请求数据大小超出允许的5M限制，无法进行防重复提交验证。')
      return config;
    }
  }
  return config;
}, function (error) {
  console.log(error)
  return Promise.reject(error);
});

// 添加响应拦截器
service.interceptors.response.use(res => {
  //未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  // const msg = errorCode[code] || res.data.msg || errorCode['default']
  // 二进制数据则直接返回
  if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
    return res.data
  }

  if (code === 401) {
    message.error({ content: '无效的会话，或者会话已过期，请重新登录', duration: 2 })
    removeToken()
    // 跳转到外部地址
    // window.location.href = 'https://portal.zjzwfw.gov.cn/uc/sso/login?appId=A330206283372202210017392&userType=person&sp=https://lxsh.bl.cn/lxcf-pc?from=zqykt'
    window.location.href = 'https://portal.zjzwfw.gov.cn/uc/sso/login?appId=A330206283372202210017392&userType=person&sp=https://lxsh.bl.cn/lxcf-pc?from=zqykt'
    return Promise.reject(new Error('请重新登录'))
  } else if (code === 500) {
    return Promise.reject(new Error("服务器繁忙，请稍后重试"))
  } else if (code !== 200) {
    return Promise.reject(res.data.msg)
  } else {
    return Promise.resolve(res.data)
  }
}, error => {
  
  let { msg } = error;

  if (msg === "Network Error") {
    msg = "后端接口连接异常";
  } else if (msg && msg.includes("timeout")) {
    msg = "系统接口请求超时";
  } else if (msg && msg.includes("Request failed with status code")) {
    msg = "系统接口" + msg.substr(msg.length - 3) + "异常";
  }

  message.error(msg || "未知错误");
  return Promise.reject(error);
});

/**
* 参数处理
* @param {*} params  参数
*/
const tansParams = (params: any) => {
  const result = { data: "" }
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    const part = encodeURIComponent(propName) + "=";
    if (value !== null && value !== "" && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
            const params = propName + '[' + key + ']';
            const subPart = encodeURIComponent(params) + "=";
            result.data += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result.data += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result.data
}


export default service